import { UseQueryResult } from "@tanstack/react-query";
import { UseFetchOptions } from "../types/StoryblokTypes";
import { useStoryblokProxy } from "./useStoryblokProxy";
import { AxiosHeaders } from "axios";
import { ClusterStory } from "../types/ClusterTypes";

interface ClusterResponse {
  storyData: ClusterStory[];
  headers: AxiosHeaders;
}

// This hook is used to fetch cluster data from Storyblok using the useStoryblokProxy hook.
export const useCluster = (
  args: UseFetchOptions,
  abortRequest?: boolean
): UseQueryResult<ClusterResponse> => {
  const storyblokData = useStoryblokProxy(args, abortRequest);

  return {
      ...storyblokData,
      data: {
        storyData: storyblokData.data?.stories,
        headers: storyblokData.data?.headers,
      },
    } as unknown as UseQueryResult<ClusterResponse>;
};
